import "./ConfirmationModal.css";
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import Propulator from "higher-order/Propulator";
import Modal from "../../../components/common/Modal";
import classNames from "classnames";
import autobind from "autobind-decorator";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import { ActionRootContext } from "higher-order/ActionRoot";

const ConfirmationModalCancelButton = ({ onClick, label, className }) => {
    const classes = classNames("cancel-button", className);
    return (
        <button className={classes} onClick={onClick}>{label}</button>
    );
};

const ConfirmationModalConfirmButton = ({ onClick, label, className, disabled }) => {
    const classes = classNames("confirm-button", className);
    return (
        <button disabled={disabled} className={classes} onClick={onClick}>{label}</button>
    );
};

@observer
class ConfirmationModal extends React.Component {
    static contextType = ActionRootContext;

    static propTypes = {
        model: PropTypes.shape({
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            message: PropTypes.string,
            customForm: PropTypes.object,
            customRender: PropTypes.func,
            renderCustomControls: PropTypes.func
        })
    };

    componentDidMount() {
        if (!isUndefined(document)) {
            document.addEventListener("keyup", this.handleEscape);
        }
    }

    componentWillUnmount() {
        if (!isUndefined(document)) {
            document.removeEventListener("keyup", this.handleEscape);
        }
    }

    @autobind
    handleEscape(e) {
        if (e.which === 27 /* esc */) {
            this.handleCancel(e);
        }
    }

    @autobind
    handleCancel(e) {
        this.props.dispatcher.emit("CANCEL_CONFIRMATION_MODAL");
    }

    @autobind
    handleConfirm(e) {
        this.props.dispatcher.emit("CONFIRM_CONFIRMATION_MODAL");
    }

    @autobind
    renderDefaultButtons() {
        return (
            <React.Fragment>
                {this.props.model.hasCallbacks && !this.props.model.hideCancelButton &&
                    <ConfirmationModalCancelButton onClick={this.handleCancel} label={this.props.model.cancelLabel} />
                }
                <ConfirmationModalConfirmButton disabled={this.props.model.customForm && !this.props.model.customForm.canSubmit} onClick={this.handleConfirm} label={this.props.model.confirmLabel} className={this.props.model.confirmClassName} />
            </React.Fragment>
        );
    }

    render() {
        const {
            model
        } = this.props;
        const modalClasses = classNames("confirmation-modal", model.modalClassName);
        return (
            <Modal modalKey="confirmationModal"
                title="Confirm"
                hideHeader={true}
                allowScrollBar={true}
                isOpen={model.isOpen}
                shouldCloseOnOverlayClick={false}
                className={modalClasses}
            >
                {!isEmpty(model.title) &&
                    <div className="modal-header">
                        {model.title}
                        {this.props.hideCloseButton &&
                            <button className="modal-close-button" onClick={this.handleCancel}>
                                <i className="icon-cancel-thin" />
                            </button>
                        }
                    </div>
                }
                {isEmpty(model.title) &&
                    isFunction(model.renderCustomTitle) &&
                    <div className="modal-header">
                        {model.renderCustomTitle()}
                    </div>
                }
                <div className="modal-body">
                    {model.message &&
                        <div className="message">{model.message}</div>
                    }
                    {isFunction(model.customRender) &&
                        model.customRender(model.customForm)
                    }
                </div>
                {!model.hideControls &&
                    <div className="button-container">
                        {isFunction(model.renderCustomControls) &&
                            model.renderCustomControls(this.handleConfirm, model.confirmLabel, this.handleCancel, model.cancelLabel)
                        }
                        {!isFunction(model.renderCustomControls) &&
                            this.renderDefaultButtons()
                        }
                    </div>
                }
            </Modal>
        );
    }

}
const propulatedConfirmationModal = Propulator(ConfirmationModal, {
    messageStore: {
        confirmationModal: "model"
    }
});

export {
    propulatedConfirmationModal as ConfirmationModal,
    ConfirmationModalCancelButton,
    ConfirmationModalConfirmButton
};
